import styled from 'styled-components';
import { Text, fontSize, palette, spacing, radius } from '@landr/maestro';

export const IMAGE_WIDTH_PX = 72;
export const TITLE_WIDTH_PX = 150;

export const Title = styled(Text)`
    width: 100%;
    color: ${palette('neutral.50')};
    display: block;
    font-size: ${fontSize('sm')};
    line-height: ${fontSize('xl')};
    margin: 0;
    padding: 0 ${spacing('md')};
    position: relative;
    text-overflow: ellipsis;
    white-space: pre-wrap;

    div {
        text-align: left;
        width: auto;
    }
`;

export const TitleWrapper = styled.div`
    align-self: center;
    display: flex;
    align-items: center;
    flex-direction: column;
    width: ${TITLE_WIDTH_PX}px;
`;

export const DetailedPackCardImageWrapper = styled.div`
    position: relative;
    height: ${IMAGE_WIDTH_PX}px;
    width: ${IMAGE_WIDTH_PX}px;
`;

export const DetailedPackCardWrapper = styled.div`
    display: flex;
    flex-direction: row;
    background-color: ${palette('neutral.900')};
    padding: ${spacing('xs')};
    border-radius: ${radius('base')};
`;

export const PlayerButtonWrapper = styled.div`
    position: absolute;
    top: calc(${IMAGE_WIDTH_PX}px / 4);
    left: calc(${IMAGE_WIDTH_PX}px / 4);
`;

export const RelativeWrapper = styled.div`
    position: relative;
`;
